export const manifest = (() => {
function __memo(fn) {
	let value;
	return () => value ??= (value = fn());
}

return {
	appDir: "_app",
	appPath: "_app",
	assets: new Set([]),
	mimeTypes: {},
	_: {
		client: {start:"_app/immutable/entry/start.DHa1k4dG.js",app:"_app/immutable/entry/app.D1IjBbSs.js",imports:["_app/immutable/entry/start.DHa1k4dG.js","_app/immutable/chunks/DAAR3e-c.js","_app/immutable/chunks/x-hq5fDG.js","_app/immutable/chunks/1NK_OeRJ.js","_app/immutable/entry/app.D1IjBbSs.js","_app/immutable/chunks/x-hq5fDG.js","_app/immutable/chunks/B1veta3r.js","_app/immutable/chunks/kCE9wz0g.js","_app/immutable/chunks/1NK_OeRJ.js","_app/immutable/chunks/C6KhNEX3.js","_app/immutable/chunks/BZ4lcC0v.js"],stylesheets:[],fonts:[],uses_env_dynamic_public:false},
		nodes: [
			__memo(() => import('./nodes/0.js')),
			__memo(() => import('./nodes/1.js')),
			__memo(() => import('./nodes/2.js')),
			__memo(() => import('./nodes/3.js'))
		],
		remotes: {
			
		},
		routes: [
			{
				id: "/",
				pattern: /^\/$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 2 },
				endpoint: null
			},
			{
				id: "/api/actions/launch",
				pattern: /^\/api\/actions\/launch\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/actions/launch/_server.ts.js'))
			},
			{
				id: "/api/decisions/inject",
				pattern: /^\/api\/decisions\/inject\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/decisions/inject/_server.ts.js'))
			},
			{
				id: "/api/dossiers/agent-memory/include",
				pattern: /^\/api\/dossiers\/agent-memory\/include\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/dossiers/agent-memory/include/_server.ts.js'))
			},
			{
				id: "/api/h2a/targets",
				pattern: /^\/api\/h2a\/targets\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/h2a/targets/_server.ts.js'))
			},
			{
				id: "/dossier/agent-memory",
				pattern: /^\/dossier\/agent-memory\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 3 },
				endpoint: null
			}
		],
		prerendered_routes: new Set([]),
		matchers: async () => {
			
			return {  };
		},
		server_assets: {}
	}
}
})();
